
// -- React Libraries
import React from 'react';
import Modal from 'react-responsive-modal';

import Dropdown, {
    // DropdownButtons,
    DropdownMenu,
    MenuItem,
    SubMenu
  } from '../../../components/uielements/dropdown';

// -- Styles
import StyleWrapper from "./Wrapper";

import USFlag from '../../../image/flags/US.png';
import AUFlag from '../../../image/flags/AU.png';
import CanadaFlag from '../../../image/flags/Canada.png';
import CHFlag from '../../../image/flags/CH.png';
import GBFlag from '../../../image/flags/GB.png';
import MXFlag from '../../../image/flags/MX.png';
import NZFlag from '../../../image/flags/NZ.png';

export default class AddBudgetModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = { 
            budget: this.props.defaultBudget,
            region: this.props.defaultRegion
        };
        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(event) {
      this.setState({budget: event.target.value});
    }

    onRegionSelected = (item) => {
        console.log( 'on region selected : ', item);
    
        if ( item.key === 'ALL'){
          /**
           * not yet handled
           */
        } else {
          this.setState({
            region: item.key,
          });
        }
      }

    render() {
        const { budget, region } = this.state;

        const menuSubmenu = (
            <DropdownMenu onClick={ (value) => this.onRegionSelected(value) }>
                {
                    this.props.storeFrontCountryCodes && this.props.storeFrontCountryCodes.map(region=> {
                        let flag;
                        /**
                        * should use the flag lib for consistency
                        **/
                        switch (region) {
                            case 'AU': flag = AUFlag; break;
                            case 'CA': flag = CanadaFlag; break;
                            case 'CH': flag = CHFlag; break;
                            case 'GB': flag = GBFlag; break;
                            case 'MX': flag = MXFlag; break;
                            case 'NZ': flag = NZFlag; break;
                            case 'US': flag = USFlag; break;
                        }
                    
                        return (
                            <MenuItem key={region}>
                                <img style={{width:'36px'}} src={flag} alt={region}></img>
                                {region}
                            </MenuItem>
                        )
                    })
                }
            </DropdownMenu>
        );

        return (
            <Modal
                open={this.props.isOpened}
                onClose={this.props.onClose}
                center
                classNames={{ modal: 'custom-modal' }}>
                <style>{"\
                    .custom-modal { padding: 0; }\
                    .custom-modal > button { top: 21px; right: 21px; }\
                    .custom-modal > button svg { width: 18px; height: 18px; color: rgba(61, 61, 61, 1); }\
                "}</style>
                <StyleWrapper>
                    <h2>Add More Budget</h2>
                    
                    <div>
                        <div>
                            You have <strong>${this.props.budgetLeft}</strong>&nbsp;of your total budget left.
                        </div>
                    </div>

                    <div>
                        <div>How much do you want to spend?</div>

                        {
                            false && (
                                <div>
                                    <div className="round-border-wrapper countries">
                                        <Dropdown overlay={menuSubmenu}>
                                            <a className="ant-dropdown-link">
                                                { region || "ALL COUNTRIES" }
                                            </a>
                                        </Dropdown>
                                    </div>
                                </div>
                            )
                        }

                        <div>
                            <div className="border-wrapper budget-selector">
                                <div className="symbol-wrapper">
                                    <div>$</div>
                                </div>

                                <div className="input-wrapper">
                                    <input
                                        value={budget}
                                        onChange={this.handleChange} />
                                </div>
                            </div>
                        </div>

                        <div>
                            <button 
                            onClick={ () => this.props.onBudgetComfirmed && this.props.onBudgetComfirmed(budget, region)} 
                            className="border-wrapper">
                                Add $ {budget}
                            </button>
                        </div>
                    </div>
                </StyleWrapper>
            </Modal>
        );
    }
};


// WEBPACK FOOTER //
// ./src/containers/Dashboard/AddBudgetModal/index.js